<template>
  <EcxInfoModal
    :open="open"
    :title="title"
    :description="subtitle"
    :variant="hasSuccessIcon ? 'success' : 'info'"
    size="lg"
    :content-boxed="true"
    :content-preserve-whitespace="withPre"
    :button-text="t('button.close')"
    @close="close"
  />
</template>

<script setup lang="ts">
import { EcxInfoModal } from '@ecx/ui';
import { useI18n } from '@/composables/useI18n';
import router from '@/router';

const { t } = useI18n();

const props = withDefaults(defineProps<{
  open?: boolean,
  title: string,
  subtitle: string,
  to?: string | undefined,
  withPre?: boolean,
  hasSuccessIcon?: boolean,
}>(), {
  open: true,
  hasSuccessIcon: true,
});

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'update:open', value: boolean): void
}>();

const close = () => {
  emit('update:open', false);
  props.to ? router.push(props.to) : emit('close');
};
</script>
